import { render, staticRenderFns } from "./ForceUpdateConfigPage.vue?vue&type=template&id=feb857d4"
import script from "./ForceUpdateConfigPage.vue?vue&type=script&lang=js"
export * from "./ForceUpdateConfigPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports